import { EntityAttributeFragment } from "gql/graphql";
import { EntityAttributesData } from "./types";
import { ALL } from "../selected-group/constants";

export function getAttributes(data: EntityAttributesData, group: string) {
  if (data?.getDynamicAttributeGroupMetaInfo === undefined) {
    return [];
  }

  let result: EntityAttributeFragment[] = [];

  const meta = data.getDynamicAttributeGroupMetaInfo;

  if (group && group === ALL) {
    result = [
      ...meta.attributes,
      ...meta.groups.flatMap((group) => group.attributes),
    ];
  } else if (group) {
    result = meta.groups.find((g) => g.id === group)?.attributes ?? [];
  }

  return result.filter(
    (attr) =>
      attr.__typename === "SimpleTypeDynamicAttributeDto" ||
      attr.__typename === "EnumTypeDynamicAttributeDto",
  );
}
